import {
  EMAIL_PROFILE_ACTION_ADD_NOTE,
  EMAIL_PROFILE_ACTION_ARCHIVE,
  EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT,
  EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT,
  EMAIL_PROFILE_ACTION_MARK_AS_UNREAD,
  EMAIL_PROFILE_ACTION_RESTORE,
} from '../../Email.constants'

export const EMAIL_PROFILE_ACTION_SUCCESS_TITLE = {
  [EMAIL_PROFILE_ACTION_ADD_NOTE]: 'Notification.EmailTitleAddNoteKey',
  [EMAIL_PROFILE_ACTION_ARCHIVE]:
    'Notification.EmailProfileMessageActionTitleArchiveKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT]:
    'Notification.EmailProfileMessageActionTitleMarkAsStarredKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT]:
    'Notification.EmailProfileMessageActionTitleMarkAsUnstarredKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_UNREAD]:
    'Notification.EmailProfileMessageActionTitleUnreadKey',
  [EMAIL_PROFILE_ACTION_RESTORE]:
    'Notification.EmailProfileMessageActionTitleRestoreKey',
}

export const EMAIL_PROFILE_ACTION_ERROR_TITLE = {
  [EMAIL_PROFILE_ACTION_ADD_NOTE]: 'Notification.EmailAddNoteErrorKey',
  [EMAIL_PROFILE_ACTION_ARCHIVE]:
    'Notification.EmailProfileMessageActionErrorTitleArchiveKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_IMPORTANT]:
    'Notification.EmailProfileMessageActionErrorMarkAsStarredKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_UNIMPORTANT]:
    'Notification.EmailProfileMessageActionErrorMarkAsUnstarredKey',
  [EMAIL_PROFILE_ACTION_MARK_AS_UNREAD]:
    'Notification.EmailProfileMessageActionErrorTitleUnreadKey',
  [EMAIL_PROFILE_ACTION_RESTORE]:
    'Notification.EmailProfileMessageActionErrorTitleRestoreKey',
}
